/*
  TMA — the sticky buy bar on a product page, phones only.

  It ships hidden and this file is the only thing that reveals it, so with no
  JavaScript nothing appears and the page is exactly what it was. The bar is
  not a second form: its button carries form="tma-pdp-form", so it submits the
  real one with whatever quantity the stepper is showing.

  It appears only once the real Add to bag has scrolled out of view — while
  that button is on screen a second copy of it is noise, not help.
*/
(function () {
  var bar = document.querySelector('[data-tma-sticky-buy]');
  if (!bar) return;

  var realButton = document.querySelector('#tma-pdp-form [name="add"]');
  if (!realButton) return;

  /* Desktop keeps the button in the right-hand column, where it is never far
     away, so the bar is a phone affordance and nothing else. */
  var phone = window.matchMedia('(max-width: 767px)');
  if (!('IntersectionObserver' in window)) return;

  var realButtonVisible = true;

  /* Shopify pins its own bar to the bottom of the viewport for anyone logged
     into the admin, at a z-index nothing is meant to beat. A customer never
     sees it, but the shop owner checking their own site does -- and it sat
     exactly on top of this bar, so the feature looked broken to the one person
     most likely to look for it.

     Measured rather than matched by class name: anything fixed to the bottom
     edge, taller than a hairline, outranking us and not us. That survives
     Shopify renaming their markup. */
  function obstructionHeight() {
    var tallest = 0;
    var all = document.body.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === bar || bar.contains(el)) continue;
      var st = window.getComputedStyle(el);
      if (st.position !== 'fixed') continue;
      var z = parseInt(st.zIndex, 10);
      if (!(z > 40)) continue;
      var r = el.getBoundingClientRect();
      if (r.height < 12) continue;
      if (Math.abs(r.bottom - window.innerHeight) > 4) continue;
      if (r.height > tallest) tallest = r.height;
    }
    return Math.round(tallest);
  }

  function apply() {
    var show = phone.matches && !realButtonVisible;
    bar.hidden = !show;
    if (!show) {
      document.body.style.paddingBottom = '';
      return;
    }
    var lift = obstructionHeight();
    bar.style.bottom = lift ? lift + 'px' : '';
    /* Hold the footer clear of the bar rather than letting it sit on top of
       the last thing on the page. */
    document.body.style.paddingBottom = bar.offsetHeight + lift + 'px';
  }

  var io = new IntersectionObserver(function (entries) {
    realButtonVisible = entries[0].isIntersecting;
    apply();
  }, { threshold: 0 });

  io.observe(realButton);

  /* The admin bar is injected after this script runs, so the first measurement
     can miss it. One re-check once the page has settled is enough. */
  window.setTimeout(apply, 1500);
  window.addEventListener('resize', apply);

  if (phone.addEventListener) phone.addEventListener('change', apply);
  else if (phone.addListener) phone.addListener(apply);

  /* Once something is in the bag the bar has done its job for this visit;
     leaving it pinned over the page afterwards is just clutter. */
  document.addEventListener('tma:cart:updated', function () {
    window.setTimeout(function () {
      bar.hidden = true;
      document.body.style.paddingBottom = '';
      io.disconnect();
    }, 1200);
  });
})();
